//#677b0e
export const topics = {
  "PP": [{
    name: 'Medio Ambiente',
    color: '#a01743',
    value: .07
  }, {
    name: 'Educación',
    color: '#008f72',
    value: .07
  }, {
    name: 'Economía',
    color: '#36b7f1',
    value: .15
  }, {
    name: 'Conflicto Catalán',
    color: '#ff1f89',
    value: .15
  }, {
    name: 'Seguridad',
    color: '#00d9be',
    value: .15
  }, {
    name: 'Prisión Permanente Revisable',
    color: '#ffb232',
    value: .08
  }, {
    name: 'Empleo',
    color: '#004aa1',
    value: .08
  }, {
    name: 'Corrupción',
    color: '#95ca15',
    value: .05
  }, {
    name: 'VIVIENDA',
    color: '#677b0e',
    value: .05
  }, {
    name: 'Mujer y políticas de género',
    color: '#ffa8ec',
    value: .15
  }],
  "PSOE": [{
    name: 'Medio Ambiente',
    color: '#a01743',
    value: .15
  }, {
    name: 'Educación',
    color: '#008f72',
    value: .07
  }, {
    name: 'Economía',
    color: '#36b7f1',
    value: .07
  }, {
    name: 'Conflicto Catalán',
    color: '#ff1f89',
    value: .08
  }, {
    name: 'Seguridad',
    color: '#00d9be',
    value: .15
  }, {
    name: 'Prisión Permanente Revisable',
    color: '#ffb232',
    value: .08
  }, {
    name: 'Empleo',
    color: '#004aa1',
    value: .05
  }, {
    name: 'Corrupción',
    color: '#95ca15',
    value: .05
  }, {
    name: 'VIVIENDA',
    color: '#677b0e',
    value: .15
  }, {
    name: 'Mujer y políticas de género',
    color: '#ffa8ec',
    value: .15
  }],
  "Cs": [{
    name: 'Medio Ambiente',
    color: '#a01743',
    value: .07
  }, {
    name: 'Educación',
    color: '#008f72',
    value: .07
  }, {
    name: 'Economía',
    color: '#36b7f1',
    value: .15
  }, {
    name: 'Conflicto Catalán',
    color: '#ff1f89',
    value: .15
  }, {
    name: 'Seguridad',
    color: '#00d9be',
    value: .15
  }, {
    name: 'Prisión Permanente Revisable',
    color: '#ffb232',
    value: .08
  }, {
    name: 'Empleo',
    color: '#004aa1',
    value: .05
  }, {
    name: 'Corrupción',
    color: '#95ca15',
    value: .08
  }, {
    name: 'VIVIENDA',
    color: '#677b0e',
    value: .15
  }, {
    name: 'Mujer y políticas de género',
    color: '#ffa8ec',
    value: .05
  }],
  "UP": [{
    name: 'Medio Ambiente',
    color: '#a01743',
    value: .07
  }, {
    name: 'Educación',
    color: '#008f72',
    value: .05
  }, {
    name: 'Economía',
    color: '#36b7f1',
    value: .07
  }, {
    name: 'Conflicto Catalán',
    color: '#ff1f89',
    value: .15
  }, {
    name: 'Seguridad',
    color: '#00d9be',
    value: .08
  }, {
    name: 'Prisión Permanente Revisable',
    color: '#ffb232',
    value: .05
  }, {
    name: 'Empleo',
    color: '#004aa1',
    value: .08
  }, {
    name: 'Corrupción',
    color: '#95ca15',
    value: .15
  }, {
    name: 'VIVIENDA',
    color: '#677b0e',
    value: .15
  }, {
    name: 'Mujer y políticas de género',
    color: '#ffa8ec',
    value: .15
  }],
  "VOX": [{
    name: 'Medio Ambiente',
    color: '#a01743',
    value: .05
  }, {
    name: 'Educación',
    color: '#008f72',
    value: .07
  }, {
    name: 'Economía',
    color: '#36b7f1',
    value: .07
  }, {
    name: 'Conflicto Catalán',
    color: '#ff1f89',
    value: .15
  }, {
    name: 'Seguridad',
    color: '#00d9be',
    value: .15
  }, {
    name: 'Prisión Permanente Revisable',
    color: '#ffb232',
    value: .15
  }, {
    name: 'Empleo',
    color: '#004aa1',
    value: .08
  }, {
    name: 'Corrupción',
    color: '#95ca15',
    value: .15
  }, {
    name: 'VIVIENDA',
    color: '#677b0e',
    value: .08
  }, {
    name: 'Mujer y políticas de género',
    color: '#ffa8ec',
    value: .05
  }],
  "ERC": [{
    name: 'Medio Ambiente',
    color: '#a01743',
    value: .05
  }, {
    name: 'Educación',
    color: '#008f72',
    value: .07
  }, {
    name: 'Economía',
    color: '#36b7f1',
    value: .07
  }, {
    name: 'Conflicto Catalán',
    color: '#ff1f89',
    value: .45
  }, {
    name: 'Seguridad',
    color: '#00d9be',
    value: .15
  }, {
    name: 'Prisión Permanente Revisable',
    color: '#ffb232',
    value: 0
  }, {
    name: 'Empleo',
    color: '#004aa1',
    value: .08
  }, {
    name: 'Corrupción',
    color: '#95ca15',
    value: 0
  }, {
    name: 'VIVIENDA',
    color: '#677b0e',
    value: .08
  }, {
    name: 'Mujer y políticas de género',
    color: '#ffa8ec',
    value: .05
  }],
  "JxCat": [{
    name: 'Medio Ambiente',
    color: '#a01743',
    value: 0
  }, {
    name: 'Educación',
    color: '#008f72',
    value: .03
  }, {
    name: 'Economía',
    color: '#36b7f1',
    value: .07
  }, {
    name: 'Conflicto Catalán',
    color: '#ff1f89',
    value: .61
  }, {
    name: 'Seguridad',
    color: '#00d9be',
    value: .15
  }, {
    name: 'Prisión Permanente Revisable',
    color: '#ffb232',
    value: 0
  }, {
    name: 'Empleo',
    color: '#004aa1',
    value: .01
  }, {
    name: 'Corrupción',
    color: '#95ca15',
    value: 0
  }, {
    name: 'VIVIENDA',
    color: '#677b0e',
    value: .08
  }, {
    name: 'Mujer y políticas de género',
    color: '#ffa8ec',
    value: .05
  }]
};
export const words = [{
  text: "Violencia",
  value: 10
}, {
  text: "Prisión",
  value: 20
}, {
  text: "Condena",
  value: 30
}, {
  text: "Fondos públicos",
  value: 40
}, {
  text: "PPR",
  value: 50
}, {
  text: "Votantes",
  value: 10
}, {
  text: "Votos",
  value: 20
}, {
  text: "Candidatura",
  value: 20
}, {
  text: "Sánchez",
  value: 30
}, {
  text: "VOX",
  value: 70
}, {
  text: "Machismo",
  value: 80
}, {
  text: "ETA",
  value: 10
}, {
  text: "28-A",
  value: 90
}, {
  text: "Papeletas",
  value: 30
}, {
  text: "Público",
  value: 20
}, {
  text: "Instituciones",
  value: 60
}, {
  text: "Soberanía",
  value: 60
}, {
  text: "Patria",
  value: 50
}, {
  text: "Constitución",
  value: 40
}, {
  text: "Autonomías",
  value: 30
}, {
  text: "Consenso",
  value: 20
}, {
  text: "Nación",
  value: 20
}, {
  text: "Golpe de estado",
  value: 70
}, {
  text: "Comicios",
  value: 80
}, {
  text: "Congreso",
  value: 90
}, {
  text: "España",
  value: 10
}, {
  text: "Españoles",
  value: 90
}];